module.exports = __webpack_public_path__ + "static/vocals-0b3c3edbd0b7bb276047dc3ad77ddfc1.jpg";